import { applicationApi } from "../../common/api";
import { OrganizationStructure } from "./types";

// Define a service using a base URL and expected endpoints
export const organizationStructureApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllOrganizationStructure: builder.query<OrganizationStructure[], void>({
      query: () => `org-structure`,
      providesTags: [{ type: "OrganizationStructures", id: "LIST" }],
    }),
    getOrganizationStructure: builder.query<OrganizationStructure, string>({
      query: (query) => `org-structure/${query}`,
    }),
    createOrganizationStructure: builder.mutation<OrganizationStructure, any>({
      query: (body) => ({
        url: "/org-structure",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "OrganizationStructures", id: "LIST" }],
    }),
    deleteOrganizationStructure: builder.mutation<any, number>({
      query: (id) => ({
        url: `org-structure/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "OrganizationStructures", id: "LIST" }],
    }),
    updateOrganizationStructure: builder.mutation<OrganizationStructure, any>({
      query: (body) => ({
        url: `/org-structure/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "OrganizationStructures", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllOrganizationStructureQuery,
  useGetOrganizationStructureQuery,
  useCreateOrganizationStructureMutation,
  useDeleteOrganizationStructureMutation,
  useUpdateOrganizationStructureMutation,
} = organizationStructureApi;
